<template>
  <section
    class="guided-mode__card guided-mode-completion"
    role="group"
    aria-describedby="guided-mode-completion-message"
  >
    <p id="guided-mode-completion-message" class="guided-mode__prompt guided-mode-completion__message">
      {{ $t('app.assessment_mode.text.completion_prompt.message') }}
    </p>
    <div class="guided-mode-completion__actions">
      <button
        type="button"
        class="guided-mode-completion__button guided-mode-completion__button--complete"
        data-testid="guided-completion-complete"
        data-analytics-skip
        @click="$emit('complete')"
      >
        {{ $t('app.assessment_mode.text.completion_prompt.complete') }}
      </button>
      <button
        type="button"
        class="guided-mode-completion__button guided-mode-completion__button--continue"
        data-testid="guided-completion-continue"
        data-analytics-skip
        @click="$emit('continue')"
      >
        {{ $t('app.assessment_mode.text.completion_prompt.continue') }}
      </button>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GuidedModeCompletionPrompt',
  emits: ['complete', 'continue'],
})
</script>
